module.exports = "<div class=\"result-page block\">\n    <div class=\"alert-bar error\">\n        <i class=\"ybicon yb-close\"></i> {{'page-verify-text028' | translate}}\n    </div>\n    <div class=\"error-content\">\n        <div class=\"block-content\">\n            <div class=\"text\">{{ verifyCtrl.message }}</div>\n            <div class=\"button\">\n                <button type=\"button\" class=\"btn btn-md btn-default\" onclick=\"javascript:history.back()\">{{'page-verify-text029' | translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page/verify/verify.error.html
// module id = 1038
// module chunks = 3